<section class="uart"
         id="textReport"
         fxLayout="column">

  <div fxLayout="column">
    <span>{{report.title}}</span>
    <span>Gerado em {{report.date}}</span>
  </div>

  <br />

  <table>
    <tr>
      <th *ngFor="let item of head;">{{item}}</th>
    </tr>
    <br />
    <tr *ngFor="let itemEvent of rows">
      <td *ngFor="let item of itemEvent">{{item}}</td>
    </tr>
  </table>
</section>
